import { JSX } from 'react'

import { IconProps } from '../../icon'

const Hide: (props: IconProps) => JSX.Element = ({
  dataTestId,
  fill,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill={fill}
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M39.8155 24.9833C40.0615 24.5898 40.0615 24.0815 39.8155 23.6879C39.586 23.3272 34.2403 14.9152 24.0082 14.9152C21.7781 14.9152 19.6136 15.3415 17.5475 16.145L11.7592 10.3566C11.2836 9.88112 10.4965 9.88112 10.021 10.3566C9.54548 10.8322 9.54548 11.6193 10.021 12.0948L36.2572 38.3146C36.5032 38.5606 36.8148 38.6754 37.1263 38.6754C37.4379 38.6754 37.7494 38.5606 37.9954 38.3146C38.4709 37.8391 38.4709 37.052 37.9954 36.5765L32.8301 31.4112C37.2083 28.9516 39.5368 25.4097 39.7991 24.967L39.8155 24.9833ZM27.3369 25.918L22.434 21.0151C22.926 20.7856 23.4507 20.638 24.0082 20.638C26.0415 20.638 27.6977 22.2941 27.6977 24.3274C27.6977 24.885 27.5665 25.4261 27.3205 25.9016L27.3369 25.918ZM31.0264 29.6075L29.1407 27.7218C29.7966 26.7215 30.1573 25.5573 30.1573 24.3274C30.1573 20.9331 27.4025 18.1783 24.0082 18.1783C22.7784 18.1783 21.6141 18.5391 20.6139 19.195L19.4661 18.0471C20.9254 17.588 22.4504 17.3584 24.0082 17.3584C31.4199 17.3584 35.8965 22.4745 37.2739 24.3274C36.4048 25.4917 34.3059 27.9349 31.0264 29.6075Z'
      fill='black'
    />
    <path
      d='M27.0418 31.0013C26.0579 31.1981 25.0249 31.2964 24.0082 31.2964C16.5801 31.2964 12.1199 26.1804 10.7425 24.3274C11.382 23.4584 12.7266 21.8678 14.7435 20.4084C15.3011 20.0149 15.4158 19.2442 15.0223 18.6867C14.6287 18.1291 13.8581 18.0144 13.3005 18.4079C10.0702 20.7364 8.36485 23.3764 8.18447 23.6715C7.93851 24.0651 7.93851 24.5734 8.18447 24.967C8.41404 25.3277 13.7597 33.7397 23.9918 33.7397C25.1888 33.7397 26.3695 33.6249 27.5173 33.3953C28.1896 33.2642 28.6159 32.6083 28.4848 31.9523C28.3536 31.2964 27.6977 30.8537 27.0418 30.9849V31.0013Z'
      fill='black'
    />
    <path
      d='M25.238 29.2467C25.238 28.5744 24.6805 28.0169 24.0082 28.0169C21.9749 28.0169 20.3187 26.3608 20.3187 24.3274C20.3187 23.6551 19.7612 23.0976 19.0889 23.0976C18.4166 23.0976 17.8591 23.6551 17.8591 24.3274C17.8591 27.7218 20.6139 30.4766 24.0082 30.4766C24.6805 30.4766 25.238 29.919 25.238 29.2467Z'
      fill='black'
    />
  </svg>
)

export default Hide
